
export class Adicional {
	idAdicional: number;
	precio: number;
	message: string;
	readOnly: boolean;
	checked: boolean;
	descripcion: string;
	idEmisor: string;
	nombre: string;
	fechaInicio: Date;
	fechaTermino: Date;

	constructor(precio, checked, readonly, idAdicional) {
		this.precio = precio;
		this.checked = checked;
		this.readOnly = readonly;
		this.idAdicional = idAdicional;
		this.message = "Valor: $" + precio.toLocaleString("es-CL", { maximumFractionDigits: 0 });
		this.descripcion = "";
		this.fechaInicio = new Date();
		this.fechaTermino = new Date();
		this.idEmisor = "";
		this.nombre = "";
	}
}
